module.exports = "/images/logout.svg?12790a2629ddfe0481b63fd94bdd8b34";